<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ?'国际汽运':'International land transport '}}</div>
			<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				{{$store.state.navShow == true ?'俄集装箱公路运输领跑者':'the leader of container road transport in Russia'}}</div>
		</Header>

		<div class="TopTitle" data-aos="fade-right">
			<!-- data-aos="fade-up-left" -->
			<div class="">
				<!-- {{this.$route.name}} -->
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<!-- fade-down -->
		<div class="ContentText" data-aos="slide-right">
			<p>{{$store.state.navShow == true ? 'MG集团在俄罗斯集装箱公路运输领域占有重要地位，拥有强大的海关资源和运输团队，货运车队配备有260余辆皮卡厢式货车、400余辆配送车，覆盖俄罗斯莫斯科全境。配有物流货物追踪系统，实时查询运踪，按门到户进行配送。' : 'Mg group plays an important role in the field of container road transportation in Russia, with strong customs resources and transportation team. The freight fleet is equipped with more than 800 pickup trucks and distribution vehicles, covering the whole territory of Moscow, Russia. And it is equipped with logistics cargo tracking system, real-time query of transportation trace, door-to-door distribution.'}}</p>
		</div>

		<div class="ContentDetails">
			<img class="ContentDetailsAutomobile"
				src="../../../assets/chinaAndRussia/CR_automobileTransportation/Automobile.png" data-aos="flip-down">
			<img v-if="$store.state.navShow == true" class="ContentDetailsAutomobile_2" src="../../../assets/chinaAndRussia/CR_automobileTransportation/Route.png" data-aos="fade-up">
			<img v-else class="ContentDetailsAutomobile_2" src="../../../assets/chinaAndRussia/CR_automobileTransportation/RouteE.png" data-aos="fade-up">
			<div class="ContentDetailsIntroduce" :style="$store.state.navShow == true ? 'top:16.5%' : 'top:10.5%'">
				<!-- <img src="../../../assets/chinaAndRussia/CR_automobileTransportation/AutomobileBackground.png"> -->
				<div class="ContentDetailsIntroduce_L" :style="$store.state.navShow == true ? '' : 'width:25%'">
					<div class="ContentDetailsIntroduce_L_T" data-aos="fade-right">
						<img src="../../../assets/chinaAndRussia/CR_automobileTransportation/list1.png">
						<div class="ContentDetailsIntroduce_L_T_Text">
							{{$store.state.navShow == true ? '时效快速稳定' : 'Fast and stable aging'}}
						</div>
					</div>
					<div class="ContentDetailsIntroduce_L_B" data-aos="fade-right">
						<img src="../../../assets/chinaAndRussia/CR_automobileTransportation/list2.png">
						<div class="ContentDetailsIntroduce_L_B_Text">
							{{$store.state.navShow == true ? '高效安全清关' : 'Efficient and safe customs clearance'}}
						</div>
					</div>
				</div>
				<div class="ContentDetailsIntroduce_R" data-aos="fade-right" :style="$store.state.navShow == true ? '' : 'width:25%'">
					<div class="ContentDetailsIntroduce_R_T">
						<img src="../../../assets/chinaAndRussia/CR_automobileTransportation/list3.png">
						<div class="ContentDetailsIntroduce_R_T_Text">
							{{$store.state.navShow == true ? '全程GPS定位' : 'Full GPS positioning'}}
						</div>
					</div>
					<div class="ContentDetailsIntroduce_R_B" data-aos="fade-right">
						<img src="../../../assets/chinaAndRussia/CR_automobileTransportation/list4.png">
						<div class="ContentDetailsIntroduce_R_B_Text">
							{{$store.state.navShow == true ? '配送班期灵活' : 'Flexible delivery schedule'}}
						</div>
					</div>
				</div>
			</div>
			<img class="ContentDetailsBackground"
				src="../../../assets/chinaAndRussia/CR_automobileTransportation/AutomobileBackground_2.png">
		</div>










		<div class="buttonImgAT">
			<!-- <img :src="imgList.bottonImg"> -->
			<img src="../../../assets/OverseasWarehouse/currency.png">
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	export default {
		components: {
			Header,
		},
		data() {
			return {
				imgList: {
					bannerImg: require('@/assets/chinaAndRussia/CR_automobileTransportation/banner.jpg'),
					// backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
					aircraft: require('@/assets/chinaAndRussia/aircraft.png'),
					bottonImg: require('@/assets/chinaAndRussia/currency.png'),
				},
			}
		},
		methods: {


		}
	}
</script>
<!-- 头部 -->
<style lang="less">
	.TopTitle {
		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(
270deg,rgba(3,0,0,.15),hsla(0,0%,100%,.15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}
	}
</style>

<style lang="less">
	.ContentDetails {
		width: 100%;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.ContentDetailsAutomobile {
			// position: absolute;
			width: 60%;
			// height: 10%;
			z-index: 2;
		}

		.ContentDetailsAutomobile_2 {
			width: 27%;
			height: 10%;
			position: absolute;
			top: 30px;
			z-index: 2;
		}

		.ContentDetailsIntroduce {
			position: absolute;
			// top: 16.5%;
			width: 86%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			background-image: url(../../../assets/chinaAndRussia/CR_automobileTransportation/AutomobileBackground.png);
			background-size: 100% 100%;
			padding: 0.65625rem 0.71875rem 0.8125rem 0.71875rem;
			// margin: 0 4%;
			z-index: 1;
			// .ContentDetailsIntroduce_L {
			// 	width: 25%;
			// }
			// .ContentDetailsIntroduce_R {
			// 	width: 30%;
			// }

			img {
				width: 1.875rem;
				height: 1.875rem;
				// margin-bottom: 0.16875rem;
			}

			&>div>div {
				margin-bottom: 0.875rem;
			}

			&>div>div:last-child {
				margin-bottom: 0;
			}

			&>div>div>div {
				font-size: 0.625rem;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
				white-space: normal;
			}

			// &> img {

			// }
		}
		.ContentDetailsBackground {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 8.875rem;
			z-index: -2;
		}

	}





	// 小标题
	.tableTitleTitle {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 0.75rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: 1.1875rem;
	}

	.buttonImgAT {
		width: 100%;
		height: 2.9375rem;
		z-index: -1;
	}
</style>
